
import React from 'react';
import { SecondaryButton } from '@etiquette-ui/buttons';
import styled from 'styled-components';
import useI18n from 'i18n/useI18n';
import { DownloadIcon } from '@etiquette-ui/icons';


const DownloadButton = ({ ...props }) => {
    const { translate } = useI18n();

    return (
        <BaseButton {...props}>
            <DownloadIcon styles={{
                svg: {
                    width: '20px',
                    height: '20px',
                    marginRight: '8px'
                } 
            }} />
            {translate('Download')}
        </BaseButton>
    )
}

export const BaseButton = styled(SecondaryButton)`
    display: flex;
    justify-content: start;
    align-items: start;
    pointer-events: all;
    margin-left: auto;
    margin-right: 15px;

    button {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: unset;
        height: 50px;
        max-height: 48px;
        padding: 0 20px;
        min-width: 100%;
        font-weight: 600;
    }

    @media( max-width: 768px ){
        button { height: 54px; }
    }
`;

export default DownloadButton;